class AddQuestionFullModalController {

    constructor() {

        this.template = Handlebars.compile($("#worldAddQuestion").html());
        this.menuTemplate = Handlebars.compile($("#fullModalMenu").html());

    }
    
    draw(categoryId, categoryName, categoryIcon, categoryColor) {

        let context = {
            categoryId: categoryId,
            categoryName: categoryName,
            categoryIcon: categoryIcon,
            categoryColor: categoryColor,
            world: world
        };

        baseController.resetStackableOrder();
        baseController.stackSimpleMenu({title: categoryName, icon: 'back', rightIcon: categoryIcon, bgColor: categoryColor}, this.menuTemplate);
        baseController.stackSimpleContent(this.template, context);

        $(document).off("input", '.countme');
        $(document).on("input", '.countme', function() {
            var countmeResult = $(this).closest('.countme-wrapper').find('.countme-result');
            var numChars = $(this).val().length;
            var maxLength = $(this).attr('maxlength');
            countmeResult.text(maxLength - numChars) ;

            if (numChars > 0) $(this).addClass('enabled'); else $(this).removeClass('enabled');

            // check send btn
            if ($('#addQuestionQuestion').val().length > 0 &&
                $('#addQuestionAnswer0Inp').val().length > 0 &&
                $('#addQuestionAnswer1Inp').val().length > 0) {
                $('#addQuestion-sendBtn').addClass('enabled');
            } else {
                $('#addQuestion-sendBtn').removeClass('enabled');
            }
        });

        $(document).off("click", '#addQuestion-sendBtn');
        $(document).on("click", '#addQuestion-sendBtn', function() {

            var errorMsg = '';

            let questionInput = $("#addQuestionQuestion");
            let answer0Input = $("#addQuestionAnswer0Inp");
            let answer1Input = $("#addQuestionAnswer1Inp");
            let answer2Input = $("#addQuestionAnswer2Inp");
            let answer3Input = $("#addQuestionAnswer3Inp");

            if(questionInput.val() == '') errorMsg += Translator.trans('TR_ERROR_PREGUNTA_VACIA') + '<br>';
            if(answer0Input.val() == '') errorMsg += Translator.trans('TR_ERROR_RESPUESTA_CORRECTA_VACIA') + '<br>';
            if(answer1Input.val() == '') errorMsg += Translator.trans('TR_ERROR_RESPUESTA_INCORRECTA_VACIA') + '<br>';

            if(errorMsg != '') {
                notify(errorMsg, "danger");
                return false
            }

            var question = {
                title: questionInput.val(),
                correct_answer:  answer0Input.val(),
                answer2: answer1Input.val()
            };
            if (answer2Input.val() != '') question.answer3 = answer2Input.val();
            if (answer3Input.val() != '') question.answer4 = answer3Input.val();

            let splashTemplate = Handlebars.compile($("#worldAddQuestionSplashScreen").html());
            let splashContext = { color: categoryColor };
            $("#jugar").html(splashTemplate(splashContext));
            loadingQuestionsScreenController.draw(splashContext);

            api.addQuestion(world.token, categoryId, question);

        });

        setTimeout(AddQuestionFullModalController.adjustHeight, 50);

    }

    static adjustHeight() {

        let wrapper = $('#addQuestion-wrapper');
        let wrapperTop = wrapper.offset().top;
        let wrapperBottom = wrapperTop + wrapper.outerHeight();

        let windowHeight = $(window).height();

        let diff = windowHeight - wrapperBottom;
        if (diff > 0) {
            let wrapperHeight = wrapper.outerHeight();
            wrapper.outerHeight(wrapperHeight + diff);
        }

    }

}
